(function () {
    'use strict';

    angular
        .module('itxApp.legacy', [
            'itxApp.preCommon',
            'itxApp.common',
            'itxApp.cmsPage',
            'ngDialog',
            'imAnalytics',
            'itxApp.header',
            'itxApp.catalog',
            'ngSanitize',
            'itxApp.wishlist'
        ])
        .run(Run);

    Run.$inject = ['$rootScope', 'ItxHeaderFct'];

    function Run($rootScope, headerFct) {
        inditex.initialize();

        $rootScope.$on('login:success', function (event, data) {
            var loginEvent = new CustomEvent('login-sucess', {
                bubbles: true,
                composed: true,
                detail: {
                    extra: data
                }
            });
            document.dispatchEvent(loginEvent);
        });
    }
})();
